import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "scroll-list" }


import { useI18n } from 'vue-i18n';
import type { RelatedApp } from '@/lib/app-data';
import { relatedSectionKey } from '../i18n-keys';
import AppRow from './AppRow.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'RelatedSection',
  props: {
    titleKey: {},
    apps: {}
  },
  setup(__props: any) {



const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_van_row, { class: "section-head" }, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, { span: "22" }, {
          default: _withCtx(() => [
            _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(t)(_unref(relatedSectionKey)(_ctx.titleKey))), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, { span: "2" }, {
          default: _withCtx(() => [
            _createVNode(_component_van_icon, {
              name: "arrow",
              size: "16",
              color: "#9ca3af"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.apps, (app) => {
        return (_openBlock(), _createBlock(AppRow, {
          key: app.id,
          app: app
        }, null, 8, ["app"]))
      }), 128))
    ])
  ]))
}
}

})